// Edit these minimum Google Maps zoom levels to experiment with link visibility.
// A link appears when the map zoom is at least its value. Unlisted types remain visible.
import { pathLengthMeters, pointAndHeadingAlongPath } from "../../../../helpers/modelBuilder/mbChatPureUtils";

export const LINK_TYPE_MIN_ZOOM = {
  motorway: 0,
  motorway_link: 0,
  trunk: 0,
  trunk_link: 0,
  primary: 0,
  primary_link: 0,
  secondary: 0,
  secondary_link: 0,
  tertiary: 14,
  tertiary_link: 14,
  residential: 14,
  unclassified: 14,
  service: 15,
  track: 15,
};

export const ALL_LINK_TYPES_ZOOM = Math.max(...Object.values(LINK_TYPE_MIN_ZOOM));

export function showLinkTypeAtZoom(type, zoom) {
  if (!Number.isFinite(zoom)) return true;
  const roadType = String(type || "").trim().toLowerCase();
  const minimumZoom = Object.prototype.hasOwnProperty.call(LINK_TYPE_MIN_ZOOM, roadType)
    ? LINK_TYPE_MIN_ZOOM[roadType] : 0;
  return zoom >= minimumZoom;
}

export function resultLinkArrow(link, startNode, endNode, zoom, minPixels = 24) {
  if (!link?.path || link.path.length < 2) return null;
  const first = link.path[0];
  const last = link.path[link.path.length - 1];
  const distanceSquared = (a, b) => (a.lat - b.lat) ** 2 + ((a.lng - b.lng) * Math.cos(a.lat * Math.PI / 180)) ** 2;
  const reverse = startNode && endNode
    ? distanceSquared(first, startNode) + distanceSquared(last, endNode) > distanceSquared(first, endNode) + distanceSquared(last, startNode)
    : startNode && distanceSquared(first, startNode) > distanceSquared(last, startNode);
  const path = reverse ? [...link.path].reverse() : link.path;
  const midpoint = path[Math.floor(path.length / 2)];
  const metersPerPixel = 156543.03392 * Math.cos(midpoint.lat * Math.PI / 180) / (2 ** zoom);
  if (pathLengthMeters(path) < minPixels * metersPerPixel) return null;
  return pointAndHeadingAlongPath(path, 0.35);
}
